import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.css';

let rootNode = document.getElementById("hangedman_game_root");

if(!rootNode) {
  rootNode = document.createElement("div");
  const body = document.body;
  if (body !== null) {
    body.appendChild(rootNode);
  }
}

ReactDOM.render(<App />, rootNode);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
